import { createContainer } from 'react-sweet-state';

import {
  type Actions,
  type ContainerProps,
  MainStore,
  PRIVATE_ACTIONS,
  type State,
} from './MainStore';

export const MainStoreContainer = createContainer<State, Actions, ContainerProps>(MainStore, {
  onInit:
    () =>
    ({ setState, dispatch }, { state }) => {
      dispatch(PRIVATE_ACTIONS.init());

      if (state) {
        setState(state);
      }
    },
  onUpdate:
    () =>
    ({ setState }, { state }) => {
      if (state) {
        setState(state);
      }
    },
});
